/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import { Link } from 'react-router-dom';
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import { config } from '../config/config'; // eslint-disable-next-line
// eslint-disable-next-line
const Footer = (props) => {
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	let today = new Date(),
		date = today.getFullYear();
	useEffect(() => {
		getLanguagePack();
		// eslint-disable-next-line
	}, []);

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setPageLanguageContent(response.data.WCS.AAA);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.AAA) {
				setPageLanguageContent(checkData?.AAA);
			}
		}
	}
	return (
		<div className='footer-area'>
			<div className='footer-widget-info'>
				<div className='container'></div>
			</div>
			<div className='copy-right-area'>
				<div className='container'>
					<div className='row'>
						<div className='col-xl-12 col-lg-12 text-center'>
							<div className='cpr-center'>
								<p>
									{pageLanguageContent['AAA005'] ? pageLanguageContent['AAA005'] : ''}© {date}{' '}
									{pageLanguageContent['AAA006'] ? pageLanguageContent['AAA006'] : ''}{' '}
									{pageLanguageContent['AAA007'] ? pageLanguageContent['AAA007'] : ''}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
